<template>
  <div class="yxtbiz-user-selector-main bc-cCFF">
    <div class="flex w100p bbF0 ptb24">
      <div class="flex align-items-center w1200 m0auto">
        <div class="hl30 fs24 fw500">{{ language().tit_dialogtitle }}</div>
        <div class="fs14 ml25 flex align-items-center c-cC8C"> {{ language().tit_dialogtip }} 
          <yxt-popover  class="yxtbiz-user-selector-tooltip" :title="language().tit_explain" width="256"  placement="top-start">
            <yxt-svg slot="reference" icon-class="question-cirlce-o" class="size-16 ml4 color-gray-6"></yxt-svg>
            <ul class="yxtbiz-signup">
              <li class="flex align-items-center"><div class="dotsmall dotdis"></div> {{ language().msg_explain_one }}</li>
              <li class="flex align-items-center"><div class="dotsmall dotdis"></div> {{ language().msg_explain_two }}</li>
            </ul>
          </yxt-popover>
        </div>
      </div>
      <i class="yxt-icon-close yxtbiz-user-selector-close c-cC59 t32" @click.stop="closeDialog()" ></i>
    </div>
    <div class="flex m0auto maxw1200 flex-value-1 bc-cCFF">
      <div class="yxtbiz-user-selector-center-left">
        <div class="yxtbiz-user-selector-center-left-wrap">
          <div class="flex space-between mb8">
            <yxt-select
                v-model="auditStatus"
                class="w180 mr24"
                :placeholder="language().lbl_registration_status"
                @change="getData()"
              >
                <yxt-option
                  v-for="item in statuList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </yxt-option>
              </yxt-select>
              <yxtf-input
                class="w260"
                v-model="query.keyword"
                :placeholder="language().msg_input"
                searchable
                clearable
                maxlength="50"
                @clear="getData()"
                @search="getData()"
              ></yxtf-input>
          </div>
          <yxt-table
            ref="multipleTable"
            :data="tableData"
            :loading="loading"
            @selection-change="handleSelectionChange"
            @row-click="handleSelectionRowChange"
            :start-custom-column="true"
            class="mr16"
            header-cell-class-name="yxtbiz-user-selector-table-header"
            cell-class-name="yxtbiz-user-selector-table-cell"
          >
            <yxt-table-column
              type="selection"
              clear-padding="left-right"
              :selectable="row => row.auditStatus === -1"
              width="34">
            </yxt-table-column>
            <yxt-table-column
              prop="fullname"
              :label="language().lbl_name"
              min-width="200">
              <template slot-scope="scope" class="flex">
                <div class="flex">
                  <div>
                    <yxtf-portrait :imgUrl="scope.row.imgUrl" size="36px" :username="scope.row.fullname" class="mr8"></yxtf-portrait>
                  </div>
                  <div class="h40">
                    <yxt-tooltip class="w200 ellipsis block fs14 h22 lh22" effect="dark" placement="top" :open-filter="true">
                      <span>
                        <yxtbiz-user-name :name="scope.row.fullname" />
                      </span>
                      <div slot="content">
                        <yxtbiz-user-name :name="scope.row.fullname" />
                      </div>
                    </yxt-tooltip>
                    <div class="c-cC75 block ellipsis w200 fs12 h20" :title="scope.row.username">{{scope.row.username}}</div>
                  </div>
                </div>
              </template>
            </yxt-table-column>
            <yxt-table-column
              prop="positionName"
              :label="language().lbl_position_name"
              min-width="120">
              <template slot-scope="scope">
                <div class="c-cC75"><yxtbiz-position-name :name="scope.row.positionName || '--'" /></div>
              </template>
            </yxt-table-column>
            <yxt-table-column
              prop="status"
              :label="language().lbl_status"
              :hide-column="false"
              min-width="120">
              <template slot-scope="scope">
                <span :class="[scope.row.auditStatus === -1 ? 'dot1' : 'dotdis', 'dot']"></span><span>{{getStatus(scope.row.auditStatus)}}</span>
              </template>
            </yxt-table-column>
          </yxt-table>
        </div>
        <div class="flex space-between pt12 pb19 pl16">
          <div class="c-cC59">{{ language().lbl_selected }} <span class="c-cC436BFF fs16">{{multipleSelectionValue.length}}</span> {{ language().lbl_people }}</div>
          <yxtf-pagination layout="prev, pager, next" :current-page.sync="current" :total="total" :page-size="query.limit" @current-change="getData" class="yxtbiz-user-selector-page-right"> </yxtf-pagination>
        </div>
      </div>
      <div class="yxtbiz-user-selector-center-right">
        <div style="position: absolute;top: 0;bottom: 55px;left: 0;right: 0;overflow: auto;padding: 24px 24px 0;">
          <yxtf-tag
            class="mb12"
            v-for="(tag, index) in multipleSelectionValue"
            :key="index"
            type="info"
            :title="tag.fullname"
            size="mini"
            closable
            :disable-transitions="false"
            @close="handleClose(tag, index)">
            <div class="yxtbiz-user-selector-tagname c-cC59">
              <yxtbiz-user-name :name="tag.fullname" />
            </div>
          </yxtf-tag>
        </div>
        <div class="yxtbiz-user-selector-tag-footer c-cC59" v-if="multipleSelectionValue.length > 0">
          <div class="pointer" @click="clearAll()">{{ language().btn_clear_all }}</div>
          <div v-if="max" :class="max >= multipleSelectionValue.length ? '' : 'c-cCRed'">
            {{max >= multipleSelectionValue.length ? language().lbl_remaining_quota : language().lbl_over_quota}}
            <span :class="`fs16 ${max >= multipleSelectionValue.length ? 'c-cC436BFF' : ''}`">{{max >= multipleSelectionValue.length ? (max - multipleSelectionValue.length) : (multipleSelectionValue.length - max)}}</span>
            {{language().lbl_people}}
          </div>
        </div>
      </div>   
    </div>
    <div class="w100p pt24 pb23 btF0 bc-cCFF">
      <div class="w1200 m0auto">
       <yxtf-button type="primary" :disabled="multipleSelectionValue.length === 0 || (max && max < multipleSelectionValue.length) || multipleSelectionValue.length > 20" @click="handleSure()">{{ multipleSelectionValue.length > 20 ? language().lbl_exceeded + 20 + language().lbl_people : language().btn_save_sign_up }}</yxtf-button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  inject: ['language'],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 0
    },
    auditStatusList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableData: [],
      multipleSelection: {},
      query: {
        auditStatus: -1,
        keyword: '',
        limit: 20,
        offset: 0
      },
      auditStatus: -1,
      loading: false,
      current: 1,
      total: 0
    };
  },
  created() {
    this.getData();
  },
  computed: {
    statuList() {
      return [
        {
          label: this.language().lbl_whole,
          value: -2
        },
        {
          label: this.language().msg_can_sign_up,
          value: -1
        },
        ...this.auditStatusList.filter(_ => _.value).map(_ => ({
          ..._,
          label: _.info ? _.info : _.label
        }))
      ];
    },
    multipleSelectionValue() {
      return Object.values(this.multipleSelection);
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.query.offset = (this.current - 1) * this.query.limit;
      this.$emit('getData', {
        ...this.query,
        auditStatus: this.auditStatus === -2 ? undefined : this.auditStatus
      }, res => {
        this.loading = false;
        this.tableData = res.datas.map(_ => ({..._, isSelectedRow: this.multipleSelection[_.id] }));
        this.total = res.paging.count;
      });
    },
    getStatus(auditStatus) {
      return (this.statuList.find(list => list.value === auditStatus) || {}).label || '';
    },
    handleSelectionChange(val) {
      const selecteds = val.map(_ => _.id);
      for (let i = 0; i < this.tableData.length; i++) {
        if (selecteds.includes(this.tableData[i].id)) {
          this.$set(this.multipleSelection, this.tableData[i].id, this.tableData[i]);
        } else {
          this.$delete(this.multipleSelection, this.tableData[i].id);
        }
      }
    },
    handleSelectionRowChange(row) {
      if (!this.multipleSelection[row.id]) {
        this.$set(this.multipleSelection, row.id, row);
        this.$refs.multipleTable.toggleRowSelection(row, true);
      } else {
        this.$delete(this.multipleSelection, row.id);
        this.$refs.multipleTable.toggleRowSelection(row, false);
      }
    },
    handleClose(row, index) {
      this.$delete(this.multipleSelection, row.id);
      this.$refs.multipleTable.toggleRowSelection(row, false);
    },
    clearAll() {
      this.multipleSelection = {};
      this.$refs.multipleTable.clearSelection();
    },
    closeDialog() {
      this.$emit('close');
    },
    handleSure() {
      this.$emit('sure', this.multipleSelectionValue);
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-user-selector-main {
  border: 1px solid #F0F0F0;
  display: flex;
  flex-direction: column;
  min-width: 130px;
  height: 100%;
  overflow:hidden;
}
.yxtbiz-user-selector-close {
  position: absolute;
  top: 24px;
  right: 24px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer; 
}
.yxtbiz-user-selector-tooltip {
  display: inline-block;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.yxtbiz-user-selector-center-left{
  width: 863px;
  padding-top: 23px;
  padding-right: 32px;
  position: relative;
  border-right: 1px solid #E9E9E9;
}
.yxtbiz-user-selector-center-left-wrap {
  height: calc(100vh - 241px);
}
.yxtbiz-user-selector-center-right {
  width: 255px;
  padding: 24px;
  position: relative;
  border-right: 1px solid #E9E9E9;
}
.yxtbiz-user-selector-tagname {
  max-width: 124px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.yxtbiz-user-selector-tag-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 55px;
  padding: 0 31px;
  display: flex;
  box-sizing: border-box;
  background: #fff;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
}
</style>